"use client";

import { SessionProvider } from "next-auth/react";
import React from "react";

// Define the props to include children
interface AuthProviderProps {
  children: React.ReactNode;
}

// Create and export the AuthProvider component
export default function AuthProvider({ children }: AuthProviderProps) {
  return <SessionProvider>{children}</SessionProvider>;
}